export default {
  title: {
    id: 'buyback_options_option_tab_title',
    defaultMessage: 'Options',
  },
  adressesTabTitle: {
    id: 'buyback_options_inner_nav_tab_navigation_title_addresses',
    defaultMessage: 'Addresses',
  },
  paymentTabTitle: {
    id: 'buyback_options_inner_nav_tab_navigation_title_Payment',
    defaultMessage: 'Payment',
  },
  pricingRulesTabTitle: {
    id: 'buyback_options_inner_nav_tab_navigation_title_pricing_rules',
    defaultMessage: 'Pricing Rules',
  },
}
